export default __webpack_public_path__ + "static/media/fibertel-logo.2491f110.png";